import { Button, Layout, Menu } from "antd"
import { Content, Header } from "antd/es/layout/layout"
import { store } from "../redux/store.js";
import Sider from "antd/es/layout/Sider"
import { useState } from "react";
import {
    MenuFoldOutlined,
    MenuUnfoldOutlined,
    DashboardOutlined,
    UserOutlined,
    SettingOutlined,
    LogoutOutlined,
    TransactionOutlined,
} from '@ant-design/icons';
import { useLocation, useNavigate } from "react-router";
import { logout } from "../redux/slices/authSlice";

const AdminSidebar = ({ renderContent }) => {
    const navigate = useNavigate();
    const location = useLocation();
    const [collapsed, setCollapsed] = useState(false);
    // const [selectedKey, setSelectedKey] = useState('1');
    const selectedKey = location.pathname.split('/').pop();

    const menuItems = [
        {
            key: 'dashboard',
            icon: <DashboardOutlined />,
            label: 'Dashboard',
        },
        {
            key: 'providers',
            icon: <UserOutlined />,
            label: 'Providers',
        },
        {
            key: 'users',
            icon: <UserOutlined />,
            label: 'Users',
        },
        {
            key: 'specialized_services',
            icon: <SettingOutlined />,
            label: 'Specialized Services',
        },
        {
            key: 'appointment',
            icon: <SettingOutlined />,
            label: 'Appointment',
        },
        {
            key: 'transactions',
            icon: <TransactionOutlined />,
            label: 'Transactions',
        },
        {
            key: 'privacy_policy',
            icon: <SettingOutlined />,
            label: 'Privacy Policy',
        },
        {
            key: 'terms_and_conditions',
            icon: <SettingOutlined />,
            label: 'Terms and Conditions',
        },
        {
            key: 'faqs',
            icon: <SettingOutlined />,
            label: 'Faqs',
        },
        // {
        //     key: 'tax_form',
        //     icon: <SettingOutlined />,
        //     label: 'Tax Form',
        // },
        {
            key: 'checkr_logs',
            icon: <SettingOutlined />,
            label: 'Checkr Logs',
        },
        {
            key: 'logout',
            icon: <LogoutOutlined />,
            label: 'Logout',
        },
    ];
    const handleClick = ({ key }) => {
        if (key == "logout") {
            store.dispatch(logout());
            navigate("/");
        } else {
            navigate(`/admin/${key}`)
        }
    }
    return (
        <Layout style={{ minHeight: '100vh' }}>
            <Sider
                collapsible
                collapsed={collapsed}
                onCollapse={setCollapsed}
                breakpoint="lg"
                collapsedWidth={80}
                trigger={null}
                width={200}
                theme="light"
                style={{
                    overflow: 'auto',
                    height: '100vh',
                    position: 'fixed',
                    left: 0,
                    top: 0,
                    bottom: 0,
                    transition: 'width 0.2s',
                    background: 'linear-gradient(180deg, #F68C72 0%, #CA9AE8 100%)',
                }}
            >
                <div style={{
                    height: 32,
                    margin: 16,
                    background: 'rgba(255, 255, 255, 0.3)',
                    borderRadius: 6,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    color: 'white',
                    fontWeight: 'bold',
                    fontSize: collapsed ? '14px' : '16px',
                }}>
                    {collapsed ? 'TJ' : 'TOJU CARES'}
                </div>
                <Menu
                    theme="light"
                    mode="inline"
                    selectedKeys={[selectedKey]}
                    items={menuItems}
                    onClick={handleClick}
                    style={{
                        background: 'transparent',
                        border: 'none',
                    }}
                />
            </Sider>
            <Layout style={{ marginLeft: collapsed ? 80 : 200, transition: 'margin-left 0.2s' }}>
                <Header style={{
                    padding: '0 24px',
                    background: '#fff',
                    display: 'flex',
                    alignItems: 'center',
                    boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                }}>
                    <Button
                        type="text"
                        icon={collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
                        onClick={() => setCollapsed(!collapsed)}
                        style={{
                            fontSize: '16px',
                            width: 64,
                            height: 64,
                        }}
                    />
                    <h1 style={{ margin: 0, marginLeft: 16 }}>Admin Dashboard</h1>
                </Header>
                <Content style={{
                    margin: '24px 16px',
                    padding: 0,
                    background: '#f0f2f5',
                    minHeight: 280,
                }}>
                    {renderContent}
                </Content>
            </Layout>
        </Layout>
    )
}
export default AdminSidebar